import request from '../../utils/request'

const preFix = '/system/address';

export const reqListAddress = (data) => {
    return request({
        url: preFix + '/page',
        method: 'POST',
        data: data
    })
}
export const reqInsertAddress = (data) => {
    return request({
        url: preFix + '/insert',
        method: 'POST',
        data: data
    })
}
export const reqUpdateAddress = (data) => {
    return request({
        url: preFix + '/update',
        method: 'POST',
        data: data
    })
}
export const reqDeleteAddressById = (data) => {
    return request({
        url: preFix + '/delete',
        method: 'get',
        params: data
    })
}
export const reqGetAddressById = (data) => {
    return request({
        url: preFix + '/detail',
        method: 'get',
        params: data
    })
}
